import { Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface ImportedInvoiceDetailRowProps {
  label: ReactNode
  value: ReactNode
}

export const ImportedInvoiceDetailRow = ({ label, value }: ImportedInvoiceDetailRowProps): ReactElement => (
  <Styled.ImportedInvoiceDetailRowWrapper>
    <Text colorVariant="discreet" variant="bodySM" weight="medium">
      {label}
    </Text>
    <Text colorVariant="label" variant="bodySM">
      {value}
    </Text>
  </Styled.ImportedInvoiceDetailRowWrapper>
)
